import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Button, Checkbox, Form, Grid, Input, Space, Typography} from 'antd';
import {AuthFormContainer} from 'components/AuthFormContainer';
import {Spinner} from 'components/ui/Spinner';
import {getIsMobile} from 'helpers/utils';
import {observer} from 'mobx-react-lite';
import {AuthRoutePaths} from 'routing/Routes';
import {appState} from 'store/AppStore';

export const LoginView: FC = observer((): JSX.Element => {
  const {t} = useTranslation();
  const screen = Grid.useBreakpoint();

  const isMobile = React.useMemo(() => getIsMobile(screen), [screen]);

  return (
    <AuthFormContainer>
      <Space direction="vertical">
        <Typography.Title level={isMobile ? 2 : 1}>{t('Sign in')}</Typography.Title>
        <Typography.Text>{t('Please enter the details below to continue.')}</Typography.Text>
        <Form onFinish={(values) => appState.login(values)} layout="vertical" autoComplete="on">
          <Form.Item
            required
            label={t('Email')}
            name="email"
            rules={[{required: true, message: String(t('Email is required.'))}, {type: 'email'}]}
          >
            <Input
              placeholder={t('Email')}
              id="current-username"
              name="current-username"
              type="email"
              autoComplete="current-username"
            />
          </Form.Item>
          <Form.Item
            name="password"
            required
            label={t('Password')}
            rules={[
              {required: true, message: String(t('Password is required.'))},
              {min: 8, message: String(t('Password must be at least 8 characters'))},
            ]}
          >
            <Input.Password
              id="current-password"
              type="password"
              name="current-password"
              placeholder="Password"
              autoComplete="current-password"
            />
          </Form.Item>
          <Form.Item>
            <Space className="flex justify-between">
              <Form.Item name="rememberMe" valuePropName="checked" noStyle>
                <Checkbox>{String(t('Remember me'))}</Checkbox>
              </Form.Item>

              <Link to={AuthRoutePaths.forgotPassword.url}>
                <Button type="link" className="p-0 h-max">
                  {String(t('Forgot password?'))}
                </Button>
              </Link>
            </Space>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {appState.isLoading ? <Spinner size="md" /> : t('Log in')}
            </Button>
            {t('Or')}{' '}
            <Link to={AuthRoutePaths.signUp.url}>
              <Button type="link" className="p-0">
                {t('sign up!')}
              </Button>
            </Link>
          </Form.Item>
        </Form>
      </Space>
    </AuthFormContainer>
  );
});
